import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"
import _imports_0 from '@/assets/sound/microphone.png'
import _imports_1 from '@/assets/sound/audioSel.png'
import _imports_2 from '@/assets/imgcaptions/icon_shangchuanS.svg'
import _imports_3 from '@/assets/imgcaptions/icon_filezip.svg'
import _imports_4 from '@/assets/imgcaptions/videoStart.svg'
import _imports_5 from '@/assets/imgcaptions/videoStop.svg'
import _imports_6 from '@/assets/sound/aiLogo.png'
import _imports_7 from '@/assets/sound/play2.png'
import _imports_8 from '@/assets/sound/pause2.svg'
import _imports_9 from '@/assets/sound/load.svg'
import _imports_10 from '@/assets/imgcaptions/icon_gongju_11.1.png'
import _imports_11 from '@/assets/svg/loding2.gif'


const _hoisted_1 = { class: "soundCommon" }
const _hoisted_2 = { class: "commonLeft" }
const _hoisted_3 = { class: "rolemodule" }
const _hoisted_4 = { class: "roleLeft" }
const _hoisted_5 = { class: "roleLeftImg" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "roleLeftTitle" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "pathmodule" }
const _hoisted_11 = { class: "pathList" }
const _hoisted_12 = { class: "pathListBox" }
const _hoisted_13 = { class: "pathmodule" }
const _hoisted_14 = { class: "selList" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "parametermodule" }
const _hoisted_17 = { class: "parameterCommon" }
const _hoisted_18 = { class: "commonSlider" }
const _hoisted_19 = { class: "parameterCommon" }
const _hoisted_20 = { class: "commonSlider" }
const _hoisted_21 = { class: "parameterCommon" }
const _hoisted_22 = { class: "commonSlider" }
const _hoisted_23 = { class: "parameterCommon" }
const _hoisted_24 = { class: "commonSlider" }
const _hoisted_25 = { class: "parameterCommon" }
const _hoisted_26 = { class: "commonSlider" }
const _hoisted_27 = { class: "commonLeftBtn" }
const _hoisted_28 = { class: "commonCenter" }
const _hoisted_29 = { class: "commonCenterInner" }
const _hoisted_30 = { class: "centerInnerTop" }
const _hoisted_31 = { class: "InnerTopInner" }
const _hoisted_32 = { class: "topInner" }
const _hoisted_33 = { class: "innerbtm" }
const _hoisted_34 = {
  key: 0,
  class: "recordInner"
}
const _hoisted_35 = { class: "recordInnerBox" }
const _hoisted_36 = { class: "recordInnerBoxIn" }
const _hoisted_37 = {
  key: 1,
  class: "audioInner"
}
const _hoisted_38 = { class: "audioInnerUp" }
const _hoisted_39 = { class: "audioInnerUpBox" }
const _hoisted_40 = {
  key: 0,
  class: "uploadBoxIconBox"
}
const _hoisted_41 = {
  key: 1,
  class: "uploadBoxShow"
}
const _hoisted_42 = { class: "uploadBoxShowInner" }
const _hoisted_43 = { class: "centerInnerBtm" }
const _hoisted_44 = { class: "centerInnerSlider" }
const _hoisted_45 = { class: "innerSliderBox" }
const _hoisted_46 = { class: "innerbtnBox" }
const _hoisted_47 = {
  key: 0,
  class: "innerbtnBoxCenter"
}
const _hoisted_48 = { class: "bottomwavesurfer" }
const _hoisted_49 = {
  id: "timeline",
  class: "wavesurfertimeInner"
}
const _hoisted_50 = {
  class: "wavesurferInner",
  id: "wavesurferId"
}
const _hoisted_51 = { class: "commonRight" }
const _hoisted_52 = { class: "commonRightBox" }
const _hoisted_53 = { class: "historyOne" }
const _hoisted_54 = { class: "historyRowOne" }
const _hoisted_55 = { class: "rowRight" }
const _hoisted_56 = { class: "rowRight" }
const _hoisted_57 = { class: "rowRight" }
const _hoisted_58 = { class: "boxLeft" }
const _hoisted_59 = { class: "rowLeft" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "loadBox" }
const _hoisted_63 = { class: "rowRight" }
const _hoisted_64 = { class: "title" }
const _hoisted_65 = { class: "roleTime" }
const _hoisted_66 = { class: "roleTxt" }
const _hoisted_67 = { class: "timeTxt" }
const _hoisted_68 = { class: "boxRight" }
const _hoisted_69 = { class: "boxRightInner" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_72 = { class: "piecedelBox" }
const _hoisted_73 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_74 = { class: "piecedelPathBox" }
const _hoisted_75 = { class: "pieceBoxmask" }

import {
  computed,
  nextTick,
  onMounted,
  ref,
  toRefs,
  reactive,
  getCurrentInstance,
  watch,
  onBeforeUnmount,
  onUnmounted,
} from "vue";
// 引入页面图标
import { applicationDetail ,soundFieList} from "@/views/captions/icon.ts";
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
import {
    Delete,
    Setting,
} from "@element-plus/icons-vue";
// 引入录音组件
import record from '../commonPage/recording.vue';
import slider from '../commonPage/slider.vue'
//接口引入
import depotApi from "@/api/sound/depot.ts";
import changeSoundApi from "@/api/sound/changeSound.ts";
// 引入音色市场模块
import timbreMarket from "../commonPage/timbreMarket.vue"
// 引入重命名模块
import rePathbox from '../commonPage/changePath.vue'
// 滑块
import sliderOther from '@/components/common/sliderOther'
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
import { timedataYmd, timedataHm ,timeInfo,timedata} from '@/components/public-method/time-method';
import WaveSurfer from "wavesurfer.js";
import Timeline from 'wavesurfer.js/dist/plugins/timeline.js';
import Regions, { RegionParams } from 'wavesurfer.js/dist/plugins/regions.js';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const token = Auth.getToken();
let { proxy } = getCurrentInstance();
// 时间处理方法
let wsRegions: Regions = Regions.create() // Regions 实例
// 生成音轨实例
let wavesurfer: WaveSurfer | null = null;
const topTimeline = Timeline.create({
  container: '#timeline',
  height: 20,
  insertPosition: 'beforebegin',
  style: {
    fontSize: '10px',
    color: '#848485',
    background:'#1B1D1F'
  },
})
const addwaves=()=>{
      wavesurfer = WaveSurfer.create({
            container: document.querySelector('#wavesurferId'),
            waveColor: 'rgba(255, 255, 255, 0.4)',
            progressColor: 'rgba(255, 255, 255, 0.5)',
            cursorColor: 'rgba(255, 255, 255, 1)',
            height: 120,
            cursorWidth: 2,
            // url: '',
            // url:proxy.getimgUrlVoice + '/' + audioUrl.value,
            plugins: [topTimeline],
            dragToSeek: true,
        });
        
        wavesurfer?.on('timeupdate', (currentTime) => {
          // console.log(currentTime)
          nowTime.value = Math.ceil(currentTime * 1000)
          totalTime.value = Math.ceil(wavesurfer?.getDuration())* 1000; // 获取总时长（秒）
        })
}
// 滑块拖拽进度
const elDrak = (data: any) => {
  // console.log(data)
  nowTime.value=data
  let percent=(data/totalTime.value).toFixed(2)
  wavesurfer.seekTo(percent, 1)
  // if(totalTime.value*1000>data){
  //   audioRef.value.currentTime = data / 1000;
  // }else{
  //   audioRef.value.currentTime =totalTime.value
  // }
 
};
onMounted(()=>{
    getChangeSound()
    // getPublic()
    addwaves()
    // loadUrl(audioUrl.value)
    // 判断是否为跳转
    let soundData=JSON.parse(localStorage.getItem('roleSound'))
        if(soundData!=undefined && soundData.voiceChangeEnable!=0){
            showRoleOne.value=soundData
        }else{
            getPublic()
        }

})
onUnmounted(()=>{
    wavesurfer?.pause()
})
const recognition=(data:string)=>{
    showRoleOne.value=JSON.parse(data)
}
const loadUrl=(url:string)=>{
//   showlodaing.value=true
  wavesurfer?.load(proxy.getimgUrlVoice  +url);
  wavesurfer?.on('loading', (percent) => {
    
        if(percent==100) {
          console.log(percent)
          showlodaing.value=false
          setTimeout(()=>{
            if (!playTypes.value) {
            wavesurfer?.pause()
            playTypes.value=false
            
          } else {
            loadImg.value=false
            wavesurfer?.play()
          }
          },1000)
          
        }
    })
    wavesurfer?.on('finish', () => {
      wavesurfer?.stop();  // 回到起点
      playTypes.value=false
      changeSoundList.value[selPlayindex.value].isPlay=false
      
    });
}
const showlodaing=ref(false)//加载
const soundField=ref('')
// 参数设置
const isRecord=ref(true)//是否tab在录音
const tabSelstyle={
    'color':'#fff'
}
const formData=ref({
    volume: 100,
    gainVc: 0,
    slow: 100,
    indexrate: 0.5,
    protect: 0.5,
    duration: 0,
    soundField:'0',
})
const nowTime=ref(0)//当前进度
const totalTime=ref(0)//总时间
const audioUrl=ref('ai/voice/original/2025/04/11/55a7ccef04ba460690b08a576631173e.mp3')//音频地址
const playTypes = ref(true);
const marketShow=ref(false)//音色市场弹窗
const openrePathShow=ref(false)//路径弹窗
const pathTxt=ref('/根目录')//路径
const upState=ref(false)//上传状态
const title=ref('')//上传文件名称
const upFileId=ref('')//上传文件ID
const showRoleOne=ref('')
const treeId=ref('0')//上传路径id
const changeSoundList=ref([])//历史记录
const playOnoff = () => {
  playTypes.value = !playTypes.value;
  if (!playTypes.value) {
    // if(onPlay.value.indexOf('Play')>-1) onPlay.value=onPlay.value.replace('Play','Pause')
    // if(onPlay.value.indexOf('original')>-1) onPlay.value=onPlay.value.replace('original','change')
    wavesurfer.pause()
  } else {
    wavesurfer.play()
    // if(onPlay.value.indexOf('Pause')>-1) onPlay.value=onPlay.value.replace('Pause','Play')
    // if(onPlay.value.indexOf('change')>-1) onPlay.value=onPlay.value.replace('change','original')
    
  }
};
// 获取角色，默认选择公开角色第一个
const getPublic=()=>{
    depotApi.getList(1, 5,1).then((res) => {
        // roleList.value = res.rows;
        console.log(res.rows[0])
        showRoleOne.value=res.rows[0]
        
    });
}

// 上传文件
const submitUpload = (file: any,) => {
    console.log('提交上传文件')
    console.log(file)
  
    // if (fileText.value == undefined || fileText.value == '' || fileText.value == null) {
    //     ElMessage.error("请上传文件!");
    //     return
    // }
    upFileId.value=''
    const isLtM = file.raw.size / 1024 / 1024;
    // console.log(isLtM)
    if (isLtM > 100) {
        ElMessage.error("请上传100M以内的文件!");
        return false
    }
    const formDatas = new FormData();
    formDatas.append('file',file.raw);
    formDatas.append('businessType','voiceChange');
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                console.log(data)
                upState.value=true
                upFileId.value=data.data.fileId
                title.value=file.name
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            

        })
}
// 打开树形弹窗
const openTree=()=>{
    openrePathShow.value=true
}
const updataTree=(data:any)=>{
    console.log(data)
    openrePathShow.value=false
    pathTxt.value=data[0]
    treeId.value=data[1]
}
// 切换音色
const openMarket=()=>{
    marketShow.value=true
}
// 音量
const updataVolume=(num: number)=>{
    formData.value.volume = num;
}
const handleChangeVolume=(num: number)=>{
    formData.value.volume = num;
}
// 话语增益
const updatagainVc=(num: number)=>{
    formData.value.gainVc = num;
}
const handleChangegainVc=(num: number)=>{
    formData.value.gainVc = num;
}
// 慢放
const updataslow=(num: number)=>{
    formData.value.slow = num;
}
const handleChangeslow=(num: number)=>{
    formData.value.slow = num;
}
// 音高
const updataindexrate=(num: number)=>{
    formData.value.indexrate = num;
}
const handleChangeindexrate=(num: number)=>{
    formData.value.indexrate = num;
}
// 强调语气
const updataprotect=(num: number)=>{
    formData.value.protect = num;
}
const handleChangeprotect=(num: number)=>{
    formData.value.protect = num;
}
const recordRef=ref()
// 录音上传返回
const updataRecord=(data:string)=>{
    upFileId.value=data
     changeSoundApi.addChange(showRoleOne.value.roleId,upFileId.value,formData.value,treeId.value).then(res=>{
        console.log(res)
        getChangeSound()
    })
}
// 生成变声音频
const toCreatVideo=()=>{
    if(isRecord.value){
        recordRef.value.updataRecording()
    }else{
        if(upFileId.value==''||upFileId.value==null){
            ElMessage({
                type: 'error',
                message: '请上传变声音频',
            })
            return
        }
        if(showRoleOne.value.roleId==undefined){
            ElMessage({
                type: 'error',
                message: '请选择角色',
            })
            return
        }
        changeSoundApi.addChange(showRoleOne.value.roleId,upFileId.value,formData.value,treeId.value).then(res=>{
            console.log(res)
            getChangeSound()
        })
    }
    
    
}
// 查询变声记录
// const getChangeSound=()=>{
//     console.log('查询变声记录')
//     changeSoundApi.getList().then(res=>{
//         console.log(res)
//         changeSoundList.value=res.rows
//         // changeSoundList.value=groupBySameDay(JSON.parse(JSON.stringify(res.rows)))
//         console.log(changeSoundList.value)
//     })
// }
const pageNum=ref(1)//当前页数
const pageSize=ref(20)//每页条数
const total=ref(0)
const getChangeSound=()=>{
    pageNum.value=1
    changeSoundApi.getList(pageNum.value,pageSize.value).then(res=>{
        console.log('查询变声记录')
        console.log(res)
        // changeSoundList.value=res.rows
        changeSoundList.value=[]
        res.rows.forEach(item=>{
            item.isPlay=false
            changeSoundList.value.push(item)
        })
        total.value=res.total
        // changeSoundList.value=groupBySameDay(JSON.parse(JSON.stringify(res.rows)))
        console.log(changeSoundList.value)
    })
}
// 滚动加载

const scrollData = () => {
    
    if(total.value<pageSize.value*pageNum.value){
        return
    }
    pageNum.value+=1
    changeSoundApi.getList(pageNum.value,pageSize.value).then(res=>{
        total.value=res.total
        // changeSoundList.value.concat(res.rows)
        res.rows.forEach(item=>{
            item.isPlay=false
            changeSoundList.value.push(item)
        })
    })
}
// 播放变声
const selPlay=ref('')
const selPlayindex=ref(-1)
const urlListening=ref('')
const audioRef=ref()
const loadImg=ref(false)
const toPlay=(data:any,index:number)=>{
    console.log(data)
    if(data.processedFileUrl==urlListening.value){
        changeSoundList.value[index].isPlay=true
        wavesurfer?.play()
        playTypes.value=true
        return
    }
    selPlay.value=data
    urlListening.value=data.processedFileUrl
    
    selPlayindex.value=index
    // showlodaing.value=true
    playTypes.value=true
    loadImg.value=true
    changeSoundList.value.forEach((item,num)=>{
        
        if(num==index){
            item.isPlay=true
        }else{
            item.isPlay=false
        }
    })
    changeSoundList.value[index].isplay=true
    setTimeout(()=>{
        // totalTime.value=Math.ceil(audioRef.value?.duration*1000) 
        loadUrl(data.processedFileUrl)
        // loadUrl('Algorithm/tts/ai/voice/changed/2025/10/17/kpylogwjrmdssfz.mp3')
    },100)
 
}
// 暂停播放
const audioStop=(index:number)=>{
    changeSoundList.value[index].isPlay=false
    playTypes.value=false
    // audioRef.value?.pause()
    wavesurfer?.pause()
}
// 将数据文件按照时间划分数组
const groupBySameDay=(array:any, timestampKey = 'createTime',batchKey='batch')=> {
  return array.sort((a, b) => b.createTime - a.createTime).reduce((acc:any, item:any) => {
    if(item.batch ==undefined){
        item.batch='batchNo'
    }
    // 将时间戳转换为日期对象
    const date = new Date(item[timestampKey]*1);
    // 创建只包含年月日的日期字符串作为键
    const dayKey = date.toLocaleDateString('en-CA'); // 格式: YYYY-MM-DD
    
    if (!acc[dayKey]) {
      acc[dayKey] = {};
    }
    
    
    // 每一天内按用户分组区分是否为批量
    const batchId=item[batchKey];
    if (!acc[dayKey][batchId]) {
      acc[dayKey][batchId] = [];
    }
      
    acc[dayKey][batchId].push(item);
    return acc;
  }, {});
}
// 删除
const delOneChange=(data:any)=>{
    console.log('删除')
    changeSoundApi.delChange(data.id).then(res=>{
        console.log(res)
        getChangeSound()
    })
}
const downThis=(data:any)=>{
    console.log('下载')
    console.log(data)
    const a = document.createElement("a");
  //   let url = baseUrl + binding.value // 若是不完整的url则需要拼接baseURL
  const url = proxy.getimgUrlVoice +data.processedFileUrl; // 完整的url则直接使用
  // 这里是将url转成blob地址，
  
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      // 将链接地址字符内容转变成blob地址
      a.href = URL.createObjectURL(blob);
      // console.log(a.href)
      a.download = data.roleName; // 下载文件的名字
      // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
      document.body.appendChild(a);
      a.click();
    });
}
onMounted(() => {
  
  proxy.$ws.onmessageVoiceChange = (message: any) => {
    // console.log("tts----------");
    // console.log(message);
    getChangeSound()
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(proxy).getimgUrlVoice + showRoleOne.value.avatar
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(showRoleOne.value.name), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(showRoleOne.value.intro), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: "roleright",
          onClick: _withModifiers(openMarket, ["stop"])
        }, " 更换音色 ")
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "moduleTitle" }, " 输出目录 ", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(pathTxt.value), 1),
          _createElementVNode("div", {
            class: "pathListBtn",
            onClick: _withModifiers(openTree, ["stop"])
          }, [
            _createVNode(_component_el_icon, {
              color: "#fff",
              size: "24"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Setting))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "moduleTitle" }, " 声场 ", -1)),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.soundField) = $event)),
            class: "parameterSel",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.soundFieChange && _ctx.soundFieChange(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(soundFieList), (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item.value,
                key: index
              }, _toDisplayString(item.label), 9, _hoisted_15))
            }), 128))
          ], 544), [
            [_vModelSelect, formData.value.soundField]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "commonTitle" }, " 音量", -1)),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(slider, {
              min: 0,
              max: 500,
              num: formData.value.volume,
              onUpdataNum: updataVolume,
              class: "sliderStyle"
            }, null, 8, ["num"]),
            _createVNode(_component_el_input_number, {
              modelValue: formData.value.volume,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.volume) = $event)),
              min: 0,
              max: 500,
              precision: 0,
              step: 1,
              "controls-position": "right",
              size: "small",
              onChange: handleChangeVolume
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "commonTitle" }, " 话语增益", -1)),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(slider, {
              min: -100,
              max: 100,
              num: formData.value.gainVc,
              onUpdataNum: updatagainVc,
              class: "sliderStyle"
            }, null, 8, ["num"]),
            _createVNode(_component_el_input_number, {
              modelValue: formData.value.gainVc,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.gainVc) = $event)),
              min: -100,
              max: 100,
              precision: 0,
              step: 1,
              "controls-position": "right",
              size: "small",
              onChange: handleChangegainVc
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "commonTitle" }, " 慢放", -1)),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(slider, {
              min: 50,
              max: 150,
              num: formData.value.slow,
              onUpdataNum: updataslow,
              class: "sliderStyle"
            }, null, 8, ["num"]),
            _createVNode(_component_el_input_number, {
              modelValue: formData.value.slow,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.slow) = $event)),
              min: 50,
              max: 150,
              precision: 0,
              step: 1,
              "controls-position": "right",
              size: "small",
              onChange: handleChangeslow
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "commonTitle" }, " 音高", -1)),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(slider, {
              min: 0,
              max: 1,
              num: formData.value.indexrate,
              precision: true,
              onUpdataNum: updataindexrate,
              class: "sliderStyle"
            }, null, 8, ["num"]),
            _createVNode(_component_el_input_number, {
              modelValue: formData.value.indexrate,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.indexrate) = $event)),
              min: 0,
              max: 1,
              precision: 2,
              step: 0.01,
              "controls-position": "right",
              size: "small",
              onChange: handleChangeindexrate
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "commonTitle" }, " 强调语气", -1)),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(slider, {
              min: 0,
              max: 1,
              num: formData.value.protect,
              precision: true,
              onUpdataNum: updataprotect,
              class: "sliderStyle"
            }, null, 8, ["num"]),
            _createVNode(_component_el_input_number, {
              modelValue: formData.value.protect,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.protect) = $event)),
              min: 0,
              max: 1,
              precision: 2,
              step: 0.01,
              "controls-position": "right",
              size: "small",
              onChange: handleChangeprotect
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", {
          class: "videoBtn",
          onClick: _withModifiers(toCreatVideo, ["stop"])
        }, "生成音频")
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", {
                class: "topInnerTab",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (isRecord.value=true), ["stop"]))
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", {
                  style: _normalizeStyle(isRecord.value?tabSelstyle:'')
                }, "录音", 4)
              ]),
              _createElementVNode("div", {
                class: "topInnerTab",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (isRecord.value=false), ["stop"]))
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", {
                  style: _normalizeStyle(!isRecord.value?tabSelstyle:'')
                }, "上传音频", 4)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              (isRecord.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(record, {
                          businessType: 'voiceChange',
                          onUpdataRecord: updataRecord,
                          ref_key: "recordRef",
                          ref: recordRef
                        }, null, 512)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!isRecord.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "audioInnerTitle" }, [
                      _createElementVNode("div", { class: "titleTop" }, [
                        _createElementVNode("span", null, "格式要求")
                      ]),
                      _createElementVNode("div", { class: "titleRow" }, [
                        _createElementVNode("span", null, "上传音频中有且只有一个人声"),
                        _createElementVNode("span", { class: "line" }),
                        _createElementVNode("span", null, "请尽量保持上传音频的音质和背景干净")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_el_upload, {
                          class: "upload-demo",
                          drag: "",
                          "show-file-list": false,
                          multiple: "",
                          "auto-upload": false,
                          onChange: submitUpload,
                          accept: ".wav,.mp3"
                        }, {
                          default: _withCtx(() => [
                            (!upState.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _cache[20] || (_cache[20] = [
                                  _createElementVNode("div", { class: "uploadBoxIcon" }, [
                                    _createElementVNode("div", { class: "iconBox" }, [
                                      _createElementVNode("div", { class: "iconInner" }, [
                                        _createElementVNode("img", { src: _imports_2 })
                                      ]),
                                      _createElementVNode("div", { class: "iconInnerText" }, [
                                        _createElementVNode("div", { class: "iconInnerTextTop" }, "点击或拖拽 音视频文件 到这里上传"),
                                        _createElementVNode("div", { class: "iconInnerTextBtm" }, "最大支持 100 M文件上传")
                                      ])
                                    ])
                                  ], -1)
                                ])))
                              : _createCommentVNode("", true),
                            (upState.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _cache[21] || (_cache[21] = _createElementVNode("img", { src: _imports_3 }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(title.value), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _withDirectives(_createVNode(_unref(sliderOther), {
                num: nowTime.value,
                max: totalTime.value,
                onUpdataNum: elDrak
              }, null, 8, ["num", "max"]), [
                [_vShow, audioUrl.value !='']
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              (selPlay.value!='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "播放",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("img", {
                          src: _imports_4,
                          onClick: playOnoff
                        }, null, 512), [
                          [_vShow, !playTypes.value]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "暂停",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("img", {
                          src: _imports_5,
                          onClick: playOnoff
                        }, null, 512), [
                          [_vShow, playTypes.value]
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _cache[23] || (_cache[23] = _createElementVNode("div", null, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _withDirectives(_createElementVNode("div", _hoisted_49, null, 512), [
              [_vShow, audioUrl.value !='']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_50, null, 512), [
              [_vShow, audioUrl.value !='']
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "commonRightTitle" }, "生成历史", -1)),
      _createElementVNode("div", _hoisted_52, [
        _createVNode(_component_el_scrollbar, {
          height: "100%",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeSoundList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "historyList",
                key: index
              }, [
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives(_createElementVNode("div", _hoisted_54, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "rowLeft" }, [
                      _createElementVNode("img", {
                        src: _imports_6,
                        alt: ""
                      })
                    ], -1)),
                    _withDirectives(_createElementVNode("div", _hoisted_55, "音频待处理", 512), [
                      [_vShow, item.status==0]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_56, "音频生成中", 512), [
                      [_vShow, item.status==1]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_57, "生成失败", 512), [
                      [_vShow, item.status<0]
                    ]),
                    _createVNode(_component_el_icon, {
                      color: "#C8C9C9",
                      onClick: _withModifiers(($event: any) => (delOneChange(item)), ["stop"]),
                      class: "historyRowOneDel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Delete))
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 512), [
                    [_vShow, item.status<2]
                  ]),
                  _createElementVNode("div", {
                    class: "historyRowTwo",
                    style: _normalizeStyle(item.status<2?{'paddingTop':'38px'}:'' || selPlayindex.value==index?{'background':'#000'}:'')
                  }, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _withDirectives(_createElementVNode("img", {
                          src: _imports_7,
                          alt: "",
                          onClick: _withModifiers(($event: any) => (toPlay(item,index)), ["stop"])
                        }, null, 8, _hoisted_60), [
                          [_vShow, (!item.isPlay&&!loadImg.value)||selPlayindex.value!=index]
                        ]),
                        _withDirectives(_createElementVNode("img", {
                          src: _imports_8,
                          alt: "",
                          onClick: _withModifiers(($event: any) => (audioStop(index)), ["stop"])
                        }, null, 8, _hoisted_61), [
                          [_vShow, item.isPlay&&!loadImg.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_62, _cache[25] || (_cache[25] = [
                          _createElementVNode("img", {
                            src: _imports_9,
                            alt: "",
                            class: "loadBoxImg"
                          }, null, -1)
                        ]), 512), [
                          [_vShow, item.isPlay&&loadImg.value&&selPlayindex.value==index]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, _toDisplayString(item.title), 1),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, _toDisplayString(item.roleName), 1),
                          _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(timedata)(item.createTime*1)), 1)
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("img", {
                          src: _imports_10,
                          alt: "",
                          onClick: _withModifiers(($event: any) => (downThis(item)), ["stop"])
                        }, null, 8, _hoisted_70),
                        _createVNode(_component_el_icon, {
                          color: "#C8C9C9",
                          onClick: _withModifiers(($event: any) => (delOneChange(item)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Delete))
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ], 512), [
                      [_vShow, item.status==2]
                    ])
                  ], 4)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", null, [
      (marketShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createVNode(timbreMarket, {
                isChange: true,
                onCloseThis: _cache[9] || (_cache[9] = ($event: any) => (marketShow.value = false)),
                onRecognition: recognition
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (openrePathShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createVNode(rePathbox, {
                onCloseThis: _cache[10] || (_cache[10] = ($event: any) => (openrePathShow.value = false)),
                onUpparentId: updataTree
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_75, _cache[27] || (_cache[27] = [
      _createElementVNode("div", { class: "maskBox" }, [
        _createElementVNode("img", {
          src: _imports_11,
          style: {"width":"90px","height":"90px"}
        }),
        _createElementVNode("span", null, "正在加载资源中，请稍候...")
      ], -1)
    ]), 512), [
      [_vShow, showlodaing.value]
    ])
  ]))
}
}

})